const LOCAL_STORAGE_DELEGATION_KEY = 'x_delegation_key';

const clearDelegationKey = () => {
  localStorage.removeItem(LOCAL_STORAGE_DELEGATION_KEY);
};

const setDelegationKey = (key: string) => {
  localStorage.setItem(LOCAL_STORAGE_DELEGATION_KEY, key);
};

const getDelegationKey = () => {
  return localStorage.getItem(LOCAL_STORAGE_DELEGATION_KEY);
};

export default {
  clearDelegationKey,
  setDelegationKey,
  getDelegationKey,
};
